<template>
    <div class="house-card" @click="toDetail">
        <div class="img-content">
            <img :src="`/api/v1/file/${item.cover}`" alt="" class="house-card-img">
        </div>
        <div class="card-name" :title="item.route">{{item.route}}</div>
        <div class="card-bottom">
            <div class="card-sub">价格：￥<span class="price-text">{{item.price|parseNum}}</span>/人</div>
            <div class="evaluate-content">
                <el-rate :value="+item.star|| 0"
                         disabled
                         show-score
                         disabled-void-color="#cccccc"
                         text-color="#ff9900"
                         style="display: flex;justify-content: flex-start;align-items: center"
                         score-template="{value}"></el-rate>
                <div>{{item.evaluate_count}} 评价</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LineCard",
        props:{
            item: {
                type: Object,
                default(){
                    return {}
                }
            },
        },
        methods:{
            toDetail(){
                this.$router.push({path: '/lineDetail', query:{id: this.item.id}})
            }
        }
    }
</script>

<style scoped lang="less">
    .house-card{
        width: 280px;
        height: 313px;
        margin: 10px;
        box-sizing: border-box;
        cursor: pointer;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        border-radius: 6px;
        overflow: hidden;
        &:hover{
            .house-card-img{
                transform: scale(1.1);
            }
            .card-name{
                color: #e44646;
            }
        }

        .img-content{
            width: 100%;
            height: 192px;
            overflow: hidden;
            .house-card-img{
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: 0.3s;
            }
        }
        .card-name{
            width: 100%;
            margin-top: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 18px;
            height: 32px;
            line-height: 32px;
            text-align: left;
            padding: 0 10px;
            box-sizing: border-box;
        }
        .card-bottom{
            padding: 10px;
            width: 100%;
            box-sizing: border-box;
        }
        .card-sub{
            color: #949494;
            font-size: 14px;
            text-align: left;
            margin: 4px 0;
        }
        .price-text{
            font-size: 20px;
            color: #e44646;
        }
        .evaluate-content{
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #949494;
            font-size: 14px;
        }
    }
</style>
